<div class="category-manager">

  <div class="category-manager__header">
    <div>
      <span class="category-manager__eyebrow">
        CATEGORIES
      </span>

      <h3>კატეგორიები</h3>
    </div>

    <button
      type="button"
      class="category-manager__add-icon"
      (click)="open(content)"
      aria-label="Add category"
    >
      <i class="fi fi-rr-plus"></i>
    </button>
  </div>


  <div
    class="category-manager__loading"
    *ngIf="load"
  >
    <div
      class="category-skeleton"
      *ngFor="let item of [1, 2, 3]"
    ></div>
  </div>


  <div
    class="category-manager__empty"
    *ngIf="!load && categories.length === 0"
  >
    <div class="category-manager__empty-icon">
      <i class="fi fi-rr-restaurant"></i>
    </div>

    <strong>
      კატეგორიები ჯერ არ არის
    </strong>

    <small>
      შექმენი პირველი კატეგორია პროდუქტების დასაჯგუფებლად.
    </small>

    <button
      type="button"
      (click)="open(content)"
    >
      <i class="fi fi-rr-plus"></i>
      {{ "CATEGORY.ADD_CATEGORY" | translate }}
    </button>
  </div>


  <div
    class="category-manager__list"
    *ngIf="!load && categories.length"
  >

    <div
      class="category-manager__item"
      *ngFor="let category of categories"
    >

      <div class="category-manager__item-icon">
        <i class="fi fi-rr-restaurant"></i>
      </div>

      <div class="category-manager__item-content">
        <strong>
          {{
            category?.titles?.[systemLang]
              || 'No title'
          }}
        </strong>

        <small>
          კატეგორია
        </small>
      </div>

      <button
        type="button"
        class="category-manager__edit"
        (click)="open(content, category)"
        aria-label="Edit category"
      >
        <i class="fi fi-rr-pencil"></i>
      </button>

    </div>

  </div>


  <button
    *ngIf="!load && categories.length"
    type="button"
    class="category-manager__add"
    (click)="open(content)"
  >
    <i class="fi fi-rr-plus"></i>

    {{ "CATEGORY.ADD_CATEGORY" | translate }}
  </button>

</div>


<ng-template
  #content
  let-modal
>

  <div class="category-modal">

    <header class="category-modal__header">

      <div>
        <span>
          {{ isEdit ? 'EDIT CATEGORY' : 'NEW CATEGORY' }}
        </span>

        <h3>
          {{
            isEdit
              ? ('EDIT' | translate)
              : ('CATEGORY.ADD_CATEGORY' | translate)
          }}
        </h3>
      </div>

      <button
        type="button"
        class="category-modal__close"
        (click)="modal.dismiss('Cross click')"
      >
        ×
      </button>

    </header>


    <div
      class="category-modal__body"
      [formGroup]="form"
    >

      <div class="category-modal__language">
        <app-language-selector
          [appId]="id"
          [showName]="false"
          [style]="false"
          (languageChanged)="addLanguageField()"
        ></app-language-selector>
      </div>


      <div formArrayName="titles">

        <div
          *ngFor="
            let item of titles.controls;
            let i = index
          "
          [formGroupName]="i"
        >

          <div
            *ngIf="
              item.get('language')?.value === selectedLanguage
            "
            class="category-field"
          >

            <label>
              {{ 'CATEGORY.TITLE_CATEGORY' | translate }}
            </label>

            <div class="category-input">
              <i class="fi fi-rr-text"></i>

              <input
                type="text"
                formControlName="value"
                [placeholder]="
                  'CATEGORY.TITLE_CATEGORY' | translate
                "
              >
            </div>

          </div>

        </div>

      </div>

    </div>


    <footer class="category-modal__footer">

      <button
        *ngIf="isEdit"
        type="button"
        class="category-modal__delete"
        [disabled]="deleteLoad"
        (click)="deleteCategory(form.value.id)"
      >

        <app-spinner
          *ngIf="deleteLoad"
          [sm]="true"
        ></app-spinner>

        <i
          *ngIf="!deleteLoad"
          class="fi fi-rr-trash"
        ></i>

        <span>
          წაშლა
        </span>

      </button>


      <div class="category-modal__footer-right">

        <button
          type="button"
          class="category-modal__cancel"
          (click)="modal.dismiss('cancel')"
        >
          გაუქმება
        </button>

        <button
          type="button"
          class="category-modal__save"
          [disabled]="isCategoryLoad"
          (click)="createOrUpdateCategory()"
        >

          <app-spinner
            *ngIf="isCategoryLoad"
            [sm]="true"
          ></app-spinner>

          <span>
            {{
              isEdit
                ? ('EDIT' | translate)
                : ('ADD' | translate)
            }}
          </span>

          <i
            *ngIf="!isCategoryLoad"
            class="fi fi-rr-arrow-small-right"
          ></i>

        </button>

      </div>

    </footer>

  </div>

</ng-template>


<app-error
  *ngIf="error"
  [title]="''"
></app-error>